import Cookies from 'js-cookie'

const TokenKey = 'SSI_user_token_'

export function getToken() {
  var value = Cookies.get(TokenKey)
  if (value === undefined) {
    return undefined
  }
  return JSON.parse(value)
}

export function setToken(token) {
  return Cookies.set(TokenKey, JSON.stringify(token))
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
